import React, { useEffect, useState } from "react";
import Base from "../layout/BaseTemplate";
import RxnTable from "../layout/components/RxnTable";
import axios from "axios";
import { Modal, Card, Badge, Row, Col, Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";

export default function ApprovedReactions() {
    const [loading, setLoading] = useState(false);
    const [approvedList, setApprovedList] = useState({
        columns: [
            {
                label: "Reaction Name",
                field: "rxnName",
            },
            {
                label: "Reaction Smarts",
                field: "rxnSmarts",
            },
            {
                label: "Reaction Description",
                field: "rxnDescription",
            },
            {
                label: "Status",
                field: "status",
            },
        ],
        data: [],
    });

    const [rxnDetail, setRxnDetail] = useState({
        dateSubmitted: "",
        rxnDescription: "",
        rxnId: "",
        rxnName: "",
        rxnSmarts: "",
        rxnSmartsDescription: "",
        rxnTags: [],
        status: "",
        synthons: []
    });

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setRxnDetail({
            dateSubmitted: "",
            rxnDescription: "",
            rxnId: "",
            rxnName: "",
            rxnSmarts: "",
            rxnSmartsDescription: "",
            rxnTags: [],
            status: "",
            synthons: []
        });
    };

    const handleShow = (row) => {
        getApprovedReactionDetail(row.rxnId);
        setShow(true);
    };

    async function getApprovedList() {
        setLoading(true);
        await axios({
            method: "GET",
            url: "/my_reactions/list_approved",
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            setApprovedList({ ...approvedList, data: res.data });
        }).catch((err) => {
            console.log(err);
        });
        setLoading(false);
    }

    async function getApprovedReactionDetail(id) {
        await axios({
            method: "GET",
            url: `/my_reactions/${id}`,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            setRxnDetail({
                dateSubmitted: res.data.dateSubmitted,
                rxnDescription: res.data.rxnDescription,
                rxnId: res.data.rxnId,
                rxnName: res.data.rxnName,
                rxnSmarts: res.data.rxnSmarts,
                rxnSmartsDescription: res.data.rxnSmartsDescription,
                rxnTags: res.data.rxnTags,
                status: res.data.status,
                synthons: res.data.synthons
            });
        }).catch((err) => {
            console.log(err);
        });
    }

    const publish = async (rxnId) => {
        try {
            const data = await axios({
                method: 'POST',
                url: `/my_reactions/${rxnId}/publish`,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            handleClose();
            getApprovedList();
            toast.success('Successfully made reaction public');
        } catch (err) {
            console.error("Failed to publish user\'s reaction", err)
        }
    }

    useEffect(() => {
        getApprovedList();
    }, []);

    return (
        <Base>
            <RxnTable
                striped
                bordered
                hover
                data={approvedList}
                loading={loading}
                actions={{
                    view: true,
                    viewLogic: (row) => handleShow(row),
                }}
            />

            <Modal size="xl" backdrop="static" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <small className="text-muted">Reaction ID: {rxnDetail.rxnId}</small>
                </Modal.Header>
                <Modal.Body>

                    <div className="text-center mb-3">
                        <small className="text-muted">Date Submitted</small>
                        <div className="fw-bold">{rxnDetail.dateSubmitted}</div>
                    </div>

                    {/* Reaction Information Card */}
                    <Card className="mb-4">
                        <Card.Header>
                            <Card.Title as="h3">Reaction Information</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group className="mb-3">
                                <Form.Label><strong>Reaction Name</strong></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={rxnDetail.rxnName}
                                    readOnly
                                    className="bg-light"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Reaction Description</strong></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={rxnDetail.rxnDescription}
                                    readOnly
                                    className="bg-light"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Reaction SMARTS</strong></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={rxnDetail.rxnSmarts}
                                    readOnly
                                    className="bg-light"
                                    style={{ fontFamily: 'monospace' }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label><strong>Reaction SMARTS Description</strong></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={rxnDetail.rxnSmartsDescription}
                                    readOnly
                                    className="bg-light"
                                />
                            </Form.Group>

                            {/* Reaction Tags */}
                            {rxnDetail.rxnTags && rxnDetail.rxnTags.length > 0 && (
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Reaction Tags</strong></Form.Label>
                                    <div className="mt-2">
                                        {rxnDetail.rxnTags.map((tag, index) => (
                                            <Badge
                                                key={index}
                                                bg="primary"
                                                className="me-2 mb-2 px-3 py-2"
                                            >
                                                {tag.label}
                                            </Badge>
                                        ))}
                                    </div>
                                </Form.Group>
                            )}
                        </Card.Body>
                    </Card>

                    {/* Synthons Information */}
                    {rxnDetail.synthons && rxnDetail.synthons.length > 0 && (
                        <Card>
                            <Card.Header>
                                <Card.Title as="h3">Synthons ({rxnDetail.synthons.length})</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {rxnDetail.synthons.map((synthon, index) => (
                                    <Card key={index} className="mb-3 border-secondary">
                                        <Card.Header className="bg-light">
                                            <h5 className="mb-0">
                                                <i className="fas fa-flask me-2"></i>
                                                {synthon.synName}
                                            </h5>
                                        </Card.Header>
                                        <Card.Body>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label><strong>Inclusion SMARTS</strong></Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={4}
                                                            value={synthon.inSmarts ? synthon.inSmarts.join('\n') : ''}
                                                            readOnly
                                                            className="bg-light"
                                                            style={{ fontFamily: 'monospace', fontSize: '0.9em' }}
                                                        />
                                                        <small className="text-muted">
                                                            {synthon.inSmarts ? synthon.inSmarts.length : 0} patterns
                                                        </small>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label><strong>Exclusion SMARTS</strong></Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={4}
                                                            value={synthon.exSmarts ? synthon.exSmarts.join('\n') : ''}
                                                            readOnly
                                                            className="bg-light"
                                                            style={{ fontFamily: 'monospace', fontSize: '0.9em' }}
                                                        />
                                                        <small className="text-muted">
                                                            {synthon.exSmarts ? synthon.exSmarts.length : 0} patterns
                                                        </small>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </Card.Body>
                        </Card>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Col>
                        <Button onClick={() => publish(rxnDetail.rxnId)}>
                            Publish
                        </Button>
                    </Col>
                    <Col className="rightText">
                    </Col>
                </Modal.Footer>
            </Modal>
        </Base>
    );
}